import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ColDef, ColGroupDef, GridApi, GridOptions, GridReadyEvent } from 'ag-grid-community';
import { AgGridActionsRendererComponent } from 'src/app/modules/shared/components/ag-grid-action-renderer/ag-grid-action-renderer.component';
import { AgGridActionsWrapperComponent } from 'src/app/modules/shared/components/ag-grid-actions-wrapper/ag-grid-actions-wrapper.component';
import { AgGridWrapperComponent } from 'src/app/modules/shared/components/ag-grid-wrapper/ag-grid-wrapper.component';
import { IAPIResponse, IBuyerRC, ILineItemDetail } from 'src/app/modules/shared/models';
import { IComponentInput } from '../../models';
import { PrInitiatorHelperService } from '../../services/pr-initiator-helper.service';
import { PrInitiatorService } from '../../services/pr-initiator.service';
import { ValidateInvalidateRequestService } from 'src/app/modules/pr-buyer/services/validate-invalidate-request/validate-invalidate-request.service';

@Component({
  selector: 'app-rc-table-form',
  templateUrl: './rc-table-form.component.html',
  styleUrls: ['./rc-table-form.component.scss']
})
export class RcTableFormComponent implements OnInit {

  @Input("componentInput") data!: IComponentInput;
  @Output() eventOutput: EventEmitter<any> = new EventEmitter<any>();

  /******** Ag Grid Variables **********/
  public gridApi !: GridApi;
  public gridColumnApi: any;

  public frameworkComponents: any;
  public context: any;

  public gridOptions: GridOptions = {
    defaultColDef: {
      editable: false,
      sortable: true,
      flex: 1,
      filter: true,
      resizable: true,
      wrapText: true,
      autoHeight: true
    },
    suppressContextMenu : false,
    suppressMenuHide : false,
    sideBar : "true",
    rowGroupPanelShow : 'always',
    headerHeight: 40,
    pagination: true,
    paginationPageSize: 25,
    rowSelection: 'multiple',
    suppressCellSelection: true,
    overlayNoRowsTemplate: 'No results found.'
  }
  public columnDefs: (ColDef | ColGroupDef)[] = [];
  rclineItemArray:any = [];
  @ViewChild('grid') grid!: AgGridWrapperComponent;
  lineItem : ILineItemDetail = { material_master : null, vendor_details : null, account_details : null, index : 0 };
  constructor(private _helperService : PrInitiatorHelperService,
    private _validateRequestService: ValidateInvalidateRequestService,
    private dp: DatePipe,
    private _prInitiatorService : PrInitiatorService) { 
      this.frameworkComponents = {
        AgGridActionsWrapperComponent: AgGridActionsWrapperComponent,
        AgGridActionsRendererComponent: AgGridActionsRendererComponent
      };
      this.context = { componentParent: this };
  }

  ngOnInit(): void {  
    console.log(this.data)
    if (this.data && this.data.rcList.length) {
      this.setColumnDefs();
      this.setRowData(this.data.rcList);
      //   setTimeout(() => {
      //     this.setActiveSelectedRow();
      //   }, 1000);
    } else {
      this._prInitiatorService.fetchRCList()
        .subscribe(({ data: rcItems }: IAPIResponse<Array<IBuyerRC>>) => {
          this.data.rcList = rcItems;
          this.setColumnDefs();
          this.setRowData(this.data.rcList);
        });
    }
  }

  // private setActiveSelectedRow() : void {
  //   const rcForm = this.data.formGroup;
  //   const rcId = rcForm.get("rcid")?.value;
  //   if(this.grid?.gridApi) {
  //     this.grid.gridApi.forEachNode(function (node : any) {
  //       node.setSelected(node.data.id === rcId);
  //     });
  //   }
  // }

  selectRCValue(rc : IBuyerRC) : void {
    console.log("test",rc)
    const rcid = rc.id as any;
    this.lineItem = {
      material_master:{
        item_category:rc.item_category,
        line_item_number:'',
        line_item_remarks:'',
        line_item_status:'RC_PASSED',
        item_desc:rc.discription_long,
        short_text:rc.discription_short,
        esn:rc.esn_number,
        quantity:rc.price_quantity,
        ordering_unit:rc.order_unit,
        price:rc.price_amount1,
        currency:rc.currency,
        delivery_date:rc.delivery_date,
        warranties:'',
        material_code:rc.material_code,
        matl_group:'',
        rcid:rc.id,
        primary_buyer_id:'',
        buyer_rate_contract_id:'',
        po_text:''
      },
      account_details:{
        gl_account:rc.gl_account,
        acc_assignment_category:rc.acc_assignment_category,
        acc_assignment_value:rc.acc_assignment_value,
        sales_order_no:rc.sales_order_no,
        eval_group:''
      },
      vendor_details:{
        vendor_code:rc.multi_supplier_id.toString(),
        vendor_location:rc.supplier_location,
        vendor_name:rc.multi_supplier_name
      }
    }

    this.rclineItemArray.push(this.lineItem);
    this.data.rcLineItems = this.rclineItemArray;
    // this.data.formGroup.patchValue(rcid);
   
  }

  /******** Ag Grid Methods **********/
  public onGridReady(params: any) : void {
    this.grid.autoSizeAll(false);
  }

  public setRowData(results : Array<IBuyerRC> = []) : void {
    this.data.rcList = results;
  }

  public onRowSelected(event : any) : void {
    const isNodeSelected : boolean = event.node.selected;
    if(isNodeSelected) {
      this.selectRCValue(event.data)
    } else{
      this.data.formGroup.reset();
      const rcIndex = this.rclineItemArray.findIndex((rc:any) => rc.id == event.data.id)
      this.rclineItemArray.slice(rcIndex,1)
    }
  }

  public setColumnDefs() : void {
    this.columnDefs = this._validateRequestService.getRcViewColumnDefs();
    // [
    //   {
    //     groupId: 'vendor_details',
    //     children: [
    //       { field: 'item_category', checkboxSelection: true, headerName: 'Item Category' },
    //       { field: 'material_code',headerName:'Material Code'},
    //       { field: 'supplier_aid', headerName: 'Supplier AID' },
    //       { field: 'discription_short', headerName: 'Short Description' },
    //       { field: 'discription_long', headerName: 'Long Desciption' },
    //       { field: 'manufacturer_name', headerName: 'Manufacturer name' },
    //       { field: 'manufacturer_aid', headerName: 'Manufacturer AID' },
    //       { field: 'price_quantity', headerName: 'Price Quality' },
    //       { field: 'order_unit', headerName: 'Order Unit' },
    //       { field: 'tax', headerName: 'TAX' },
    //       { field: 'price_ammount', headerName: 'Price Amount' },
    //       { field: 'currency', headerName: 'Currency' },
    //     ],
    //   },
    //   {
    //     groupId: 'account_details',
    //     children: [
    //       { field: 'quantity_min',  width: 100, headerName: 'Quantity MIN' },
    //       { field: 'quantity_interval',  width: 100, headerName: 'Quality Interval' },
    //       { field: 'delivery_time',  width: 100, headerName: 'Delivery time' },
    //       { field: 'category1',  width: 100, headerName: 'Category 1' },
    //       { field: 'mime_info',  width: 100, headerName: 'MIME Info' },
    //       { field: 'datasheet',  width: 100, headerName: 'Datasheet' },
    //       { field: 'keyword',  width: 100, headerName: 'KEYWORD' },
    //       { field: 'intrastat_net_weight',  width: 100, headerName: 'Intrastat Net Weight' },
    //       { field: 'intrastat_gross_weight',  width: 100, headerName: 'Intrastat Gross Weight' },
    //       { field: 'intrastat_weight_unit',  width: 100, headerName: 'Intrastat Weight Unit' },
    //       { field: 'packaging_width',  width: 100, headerName: 'Packaging Width' },
    //       { field: 'packaging_height',  width: 100, headerName: 'Packaging Height' },
    //       { field: 'packaging_depth',  width: 100, headerName: 'Packaging Depth' },
    //       { field: 'inco_term',  width: 100, headerName: 'Incoterm' },
    //       { field: 'inco_terms_city',  width: 100, headerName: 'Incoterms City' },
    //       { field: 'eccn',  width: 100, headerName: 'ECCN' },
    //       { headerName: 'HSN SAC Code',  width: 100, field: 'hsn_sac_code' },
    //       { headerName: 'ESN Number',  width: 100, field: 'esn_number' },
    //       { headerName: 'Tax Code',  width: 100, field: 'tax_code' },
    //       { headerName: 'Multi Supplier ID',  width: 100, field: 'multi_supplier_id' },
    //       { headerName: 'Multi Supplier Name',  width: 100, field: 'multi_supplier_name' },
    //       { headerName: 'Rate Contract Validity',  width: 100, field: 'rate_contract_validity', valueFormatter: (params: any) => {
    //         const value = params.value? params.value.split("T")[0].replace(/(\d{2})-(\d{2})-(\d{4})/, "$2/$1/$3"): params.value;
    //         if(value) {
    //           return this.dp.transform(value, 'dd-MM-yyyy', 'es-ES');
    //         }
    //         return params.value;
    //       } }
    //     ],
    //   }
    // ];
  }

}
